import React from 'react';
import _ from 'lodash';
import '../../datatables/DatatablesDefault';
import '../../../resources/css/datatables.css';

class Datatable extends React.Component {
    constructor(props, context) {
        super(props, context);
        this._editor = null;
        this._destroyComplete = false;
    }

    componentDidMount() {
        // console.log('componentDidMount');
        const props = this.props;
        const dotDomClassName = '.' + props.DomClassName;
        const that = this;

        that._editor = new $.fn.dataTable.Editor({
            "ajax": {
                "create": props.editorCreate,
                "edit": props.editorEdit,
                "remove": props.editorRemove,
            },
            "table": $(this.table),
            "fields": props.editorFields
        });

        if (props.editorEditVisible === true)
            $(dotDomClassName).find('table').on('click', 'button.edit', function (e) {
                if (props.editorEditVisibleColumns)
                    _.each(props.editorEditVisibleColumns, function (column) {
                        console.log('show ' + column);
                        that._editor.field(column).show();
                    });

                if (props.editorEditHiddenColumns)
                    _.each(props.editorEditHiddenColumns, function (column) {
                        console.log('hide ' + column);
                        that._editor.field(column).hide();
                    });

                that._editor
                    .title(props.editorEditTitle)
                    .buttons($.editor.buttons.getUpdateButtons(that._editor))
                    .edit($(this).closest('tr'));
            });

        if (props.editorRemoveVisible === true)
            $(dotDomClassName).find('table').on('click', 'button.remove', function (e) {
                that._editor
                    .title(props.editorRemoveTitle)
                    .message(props.editorRemoveMessage)
                    .buttons($.editor.buttons.getDeleteButtons(that._editor))
                    .remove($(this).closest('tr'));
            });

        let defaultContent = '';

        if (props.editorEditVisible === true)
            defaultContent += '<button href="javascript:;" class="btn btn-default btn-xs edit" aria-label="Editar">' +
                '<span class="glyphicon glyphicon-pencil" aria-hidden="true"></span>' +
                '</button>&nbsp;';

        if (props.editorRemoveVisible === true)
            defaultContent += '<button href="javascript:;" class="btn btn-danger btn-xs remove" aria-label="Remover">' +
                '<span class="glyphicon glyphicon-remove" aria-hidden="true"></span>' +
                '</button>';

        let columns = props.datatablesColumns;

        if (defaultContent !== '')
            columns.push({
                data: null,
                orderable: false,
                searchable: false,
                width: 60,
                defaultContent: defaultContent
            });

        let buttons = _.map($.fn.dataTable.defaults.buttons, (x) => x); // Clone

        if (props.editorCreateVisible) {
            let addButton = {
                text: '<span class="glyphicon glyphicon-plus" aria-hidden="true"></span>',
                titleAttr: 'Adicionar',
                action: function () {
                    if (props.editorCreateVisibleColumns)
                        _.each(props.editorCreateVisibleColumns, function (column) {
                            console.log('show ' + column);
                            that._editor.field(column).show();
                        });

                    if (props.editorCreateHiddenColumns)
                        _.each(props.editorCreateHiddenColumns, function (column) {
                            console.log('hide ' + column);
                            that._editor.field(column).hide();
                        });

                    that._editor
                        .title(props.editorCreateTitle)
                        .buttons($.editor.buttons.getInsertButtons(that._editor))
                        .create();
                }
            };

            buttons.push(addButton);
        }

        if (props.buttons) {
            _.each(props.buttons, function (btn) {
                buttons.push(btn);
            });
        }

        let args = {
            "ajax": props.datatablesSelect,
            "columns": columns,
            "buttons": buttons,
            "order": props.order ? props.order : [[0, "asc"]],
            "pageLength": props.pageLength ? props.pageLength : 10,
        };

        if (props.dom)
            args = Object.assign({}, args, {dom: props.dom});

        if (props.headerCallback) {
            args = Object.assign({}, args, {headerCallback: props.headerCallback});
        }

        if (props.footerCallback) {
            args = Object.assign({}, args, {footerCallback: props.footerCallback});
        }

        let dt = $(this.table).DataTable(args);

        if (props.postCreation)
            props.postCreation(dt);
    }

    componentWillUnmount(){
        // console.log('componentWillUnmount');
        this.destroy();
    }

    destroy() {
        if (this._editor) {
            this._editor.destroy();
            this._editor = null;
        }

        $(this.table)
            .DataTable()
            .destroy(this._destroyComplete);

        this._destroyComplete = false;
    }

    shouldComponentUpdate(nextProps) {
        let ret = nextProps.title !== this.props.title
            || nextProps.subTitle !== this.props.subTitle
            || nextProps.datatablesSelect !== this.props.datatablesSelect;
        // Se o datatables for apenas atualizado, não destruir o HTML original completamente
        this._destroyComplete = !ret;
        return ret;
    }

    componentWillUpdate() {
        // console.log('componentWillUpdate');
        this.destroy();
    }

    componentDidUpdate() {
        // console.log('componentDidUpdate');
        this.componentDidMount();
    }

    render() {
        return (
            <div className={this.props.DomClassName}>
                <div className="row">
                    <div className="col-md-12 col-lg-12 col-sm-12">
                        <h3 className="page-title">
                            {this.props.title}{' '}<small>{this.props.subTitle}</small>
                        </h3>
                    </div>
                </div>

                <div className="row">
                    <div className="col-md-12 col-lg-12 col-sm-12">
                        {this.props.responsive === true &&
                            <div className="table-responsive">
                                <table ref={(ref) => { this.table = ref; }}
                                       className="table table-striped table-bordered table-hover order-column dataTable no-footer table-condensed"
                                       width="100%"/>
                            </div>
                        }
                        {this.props.responsive !== true &&
                            <table ref={(ref) => { this.table = ref; }}
                                   className="table table-striped table-bordered table-hover order-column dataTable no-footer table-condensed"
                                   width="100%"/>
                        }
                    </div>
                </div>
            </div>);
    }
}

export default Datatable;


// WEBPACK FOOTER //
// src/views/controls/Datatable.jsx